module.exports = __webpack_public_path__ + "img/storage.13c638f9.svg";